import { createApp } from "vue/dist/vue.esm-bundler.js"
import { useVuelidate } from "@vuelidate/core";
import { required, email, sameAs, requiredIf } from "@vuelidate/validators";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import recaptcha from '../components/recaptcha';

createApp({
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        VueDatePicker,
        recaptcha
    },
    computed: {
        submitEnabled() {
            return this.recaptchaPassed;
        }
    },
    data() {
        return {
            currentPage: 1,
            recaptchaPassed: false,
            page1: {
                firstName: '',
                lastName: '',
                address: '',
                city: '',
                state: '',
                zip: '',
                contact: null,
                email: '',
                confirmEmail: '',
                phone: ''
            },
            page2: {
                dateOfEvent: null,
                location: '',
                description: ''
            },
            pageProgress: 1,
            states: {
                "AL": { name: "Alabama" },
                "AK": { name: "Alaska" },
                "AZ": { name: "Arizona" },
                "AR": { name: "Arkansas" },
                "CA": { name: "California" },
                "CO": { name: "Colorado" },
                "CT": { name: "Connecticut" },
                "DE": { name: "Delaware" },
                "FL": { name: "Florida" },
                "GA": { name: "Georgia" },
                "HI": { name: "Hawaii" },
                "ID": { name: "Idaho" },
                "IL": { name: "Illinois" },
                "IN": { name: "Indiana" },
                "IA": { name: "Iowa" },
                "KS": { name: "Kansas" },
                "KY": { name: "Kentucky" },
                "LA": { name: "Louisiana" },
                "ME": { name: "Maine" },
                "MD": { name: "Maryland" },
                "MA": { name: "Massachusetts" },
                "MI": { name: "Michigan" },
                "MN": { name: "Minnesota" },
                "MS": { name: "Mississippi" },
                "MO": { name: "Missouri" },
                "MT": { name: "Montana" },
                "NE": { name: "Nebraska" },
                "NV": { name: "Nevada" },
                "NH": { name: "New Hampshire" },
                "NJ": { name: "New Jersey" },
                "NM": { name: "New Mexico" },
                "NY": { name: "New York" },
                "NC": { name: "North Carolina" },
                "ND": { name: "North Dakota" },
                "OH": { name: "Ohio" },
                "OK": { name: "Oklahoma" },
                "OR": { name: "Oregon" },
                "PA": { name: "Pennsylvania" },
                "RI": { name: "Rhode Island" },
                "SC": { name: "South Carolina" },
                "SD": { name: "South Dakota" },
                "TN": { name: "Tennessee" },
                "TX": { name: "Texas" },
                "UT": { name: "Utah" },
                "VT": { name: "Vermont" },
                "VA": { name: "Virginia" },
                "WA": { name: "Washington" },
                "WV": { name: "West Virginia" },
                "WI": { name: "Wisconsin" },
                "WY": { name: "Wyoming" }
            }
        };
    },
    methods: {
        async validatePage(page) {
            var isValid = await this.v$.page1.$validate();

            return isValid;
        },
        goToPage(page) {
            this.currentPage = page;
        },
        async nextPage() {
            if (await this.validatePage(1)) {
                this.currentPage = 2;
                this.pageProgress = 2;
            }
        },
        previousPage() {
            this.currentPage = 1;
        },
        async submitForm() {
            var isValid = await this.v$.page2.$validate();

            if (isValid) {
                $('#spillDischargeForm').submit();
            }
        },
        recaptchaCallback(newState) {
            this.recaptchaPassed = !!newState;
        }
    },
    validations() {
        return {
            page1: {
                firstName: { required },
                lastName: { required },
                address: { required },
                city: { required },
                state: { required },
                zip: { required },
                email: { required: requiredIf(function () { return this.page1.contact === 'Y' }), email },
                confirmEmail: { required: requiredIf(function () { return this.page1.contact === 'Y' }), email, sameAsEmail: sameAs(this.page1.email) }
            },
            page2: {
                dateOfEvent: { required },
                location: { required },
                description: { required }
            }
        }
    }
}).mount('#spillDischargeFormApp');
